module.exports = __webpack_public_path__ + "static/media/account-lock.4f3becae.svg";